<ng-container *ngIf="vo$ | async; let vo">
	<dx-data-grid
		keyExpr="id"
		[elementAttr]="{ id: 'permission-config-list', class: 'app-permission-config-list' }"
		[dataSource]="vo.elements"
		[hoverStateEnabled]="true"
		[showColumnHeaders]="true"
		[allowColumnResizing]="true"
		[columnAutoWidth]="false"
		[showRowLines]="false"
		[showColumnLines]="false"
		[rowAlternationEnabled]="false"
		[showBorders]="false"
		[scrolling]="{ mode: 'standard', showScrollbar: 'always' }"
		[columnFixing]="{ enabled: true }"
		[width]="'100%'">

		<dxi-column
			[dataField]="''"
			dataType="string"
			[fixed]="true"
			fixedPosition="left"
			[allowResizing]="true"
			[allowHiding]="true"
			[allowGrouping]="true"
			[alignment]="'left'"
			[visibleIndex]="0"
			cellTemplate="elementTemplate"
			[width]="250">
		</dxi-column>

		<ng-container *ngFor="let col of vo.columns; let i = index">
			<dxi-column
				[dataField]="col.permission"
				dataType="boolean"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="false"
				[allowGrouping]="true"
				[allowSorting]="false"
				[alignment]="'left'"
				[visibleIndex]="i + 1"
				cellTemplate="permissionTemplate"
				[headerCellTemplate]="!vo.config.inViewMode ? 'permissionHeaderTemplate' : ''"
				[width]="vo.config.columnWidth">
			</dxi-column>
		</ng-container>

		<div class="element-template"
				 *dxTemplate="let cell of 'elementTemplate'">
				<span
					matTooltip="{{ cell.data['element'] }}">
					{{ cell.data['element']  | truncate: 20:1:'end'}}
				</span>
				<mat-slide-toggle
                    *ngIf="!vo.config.inViewMode"
					class="small-toggle"
					id="{{cmpId}}-{{ cell.rowIndex }}-select-row"
					color="primary"
					[checked]="cell.data['allToggled']"
					(change)="onRowToggle(cell.key, $event.checked)"></mat-slide-toggle>
		</div>

		<div class="permission-header-template"
				 *dxTemplate="let cell of 'permissionHeaderTemplate'">
				<ng-container
					*ngTemplateOutlet="permissionTemplate; context: { $implicit: cell.column['dataField'] }"></ng-container>
				<mat-slide-toggle
					*ngIf="vo.list.availablePermissions.get(cell.column['dataField']) as permission"
					class="small-toggle"
					id="{{ cmpId }}-{{ cell.columnIndex }}-select-column"
					color="primary"
					[disabled]="permission.isDisabled"
					[checked]="permission.toggled"
					(change)="onColumnToggle(cell.column['dataField'], $event.checked)"></mat-slide-toggle>
		</div>

		<div class="permission-template"
				 *dxTemplate="let cell of 'permissionTemplate'">
			<ng-container
				*ngTemplateOutlet="toggleTemplate; context: {
				$implicit: cell,
				permission: vo.list.availablePermissions.get(cell.column['dataField']) }">
			</ng-container>
		</div>
	</dx-data-grid>

	<ng-template #toggleTemplate let-cell let-permission="permission">
		<mat-slide-toggle
			*ngIf="!vo.config.inViewMode && permission"
			class="small-toggle"
			id="{{ cmpId }}-{{ cell.rowIndex }}-{{ cell.columnIndex }}-select"
			[disabled]="permission.isDisabled"
			[checked]="cell.data['permissions'].has(cell.column['dataField'])"
			(change)="onToggleChange(cell.key, cell.column['dataField'], $event.checked)">
		</mat-slide-toggle>

		<ng-container *ngIf="vo.config.inViewMode">
			<mat-icon
				*ngIf="!cell.data['permissions'].has(cell.column['dataField'])"
				class="permission-not-checked"
				[svgIcon]="DcIcons.Check"></mat-icon>

			<mat-icon
				*ngIf="cell.data['permissions'].has(cell.column['dataField'])"
				class="permission-checked"
				[svgIcon]="DcIcons.Check"></mat-icon>
		</ng-container>
	</ng-template>

</ng-container>

<ng-template #permissionTemplate let-type>
	<div [ngSwitch]="type">
		<span
			*ngSwitchCase="EligiblePermissions.Read"
			i18n="@@permission.read">read</span>
		<span
			*ngSwitchCase="EligiblePermissions.Write"
			i18n="@@permission.write">write</span>
		<span
			*ngSwitchCase="EligiblePermissions.Delete"
			i18n="@@permission.delete">delete</span>
		<span
			*ngSwitchCase="EligiblePermissions.Export"
			i18n="@@permission.export">export</span>
		<span
			*ngSwitchCase="EligiblePermissions.Share"
			i18n="@@permission.share">share</span>
		<span
			*ngSwitchCase="EligiblePermissions.PersistAndCacheData"
			i18n="@@permission.persistAndCacheData">persist</span>
		<span
			*ngSwitchCase="EligiblePermissions.ManageLink"
			i18n="@@permission.manageLink">manage-link</span>
		<span
			*ngSwitchCase="EligiblePermissions.ManagePermission"
			i18n="@@permission.managePermission">manage-permission</span>
		<span
			*ngSwitchCase="EligiblePermissions.ManageDataCatalogue"
			i18n="@@permission.manageDataCatalogue">manage-data-catalogue</span>
		<span *ngSwitchDefault
			i18n="@@permission.unknown">unknown-permission</span>
	</div>
</ng-template>
